export const Urls = {
    GetCustomerCarbonAccountingEnrollments: "carbonAccountingEnrollment/GetCustomerCarbonAccountingEnrollments",
    SaveCarbonAccountingEnrollments: "carbonAccountingEnrollment/SaveCarbonAccountingEnrollments",
    GetCustomerCarbonAccountingAlerts: "carbonAccountingEnrollment/GetCustomerCarbonAccountingAlerts",
    SaveCustomerCaBusinessUnitVetAlerts: "carbonAccountingEnrollment/SaveCustomerCaBusinessUnitVetAlerts",
    GetCaEnrollmentDataForSummary: "carbonAccountingEnrollment/GetCaEnrollmentDataForSummary",
    GetCustomerCACustomReportFilters: "carbonAccountingEnrollment/GetCustomerCACustomReportFilters",
    SaveCustomerCACustomReportFilters: "carbonAccountingEnrollment/SaveCustomerCACustomReportFilters"
}